import { useGLTF } from '@react-three/drei';
import { memo } from 'react';

type Props = {
  pos?: Array<number>;
};

const GiantMushroom = ({ pos = [0.55, 0.04, 0.26] }: Props) => {
  const { scene } = useGLTF('/special/mushroom.glb');
  return (
    <primitive
      object={scene.clone()}
      scale={0.008}
      position={[pos[0], pos[1], pos[2]]}
    />
  );
};

export default memo(GiantMushroom);
